import React from "react";
import Head from "next/head";
import { AppProvider } from "@shopify/polaris";
import { Provider, useAppBridge } from "@shopify/app-bridge-react";
import { authenticatedFetch } from "@shopify/app-bridge-utils";
import {
  ApolloClient,
  InMemoryCache,
  ApolloProvider,
  HttpLink,
} from "@apollo/client";
import translations from "@shopify/polaris/locales/en.json";

import "@shopify/polaris/dist/styles.css"; // for old version
import DiscountState from "../context/discount/DiscountState";

import "/node_modules/bootstrap/scss/bootstrap.scss";
import "./styles/globals.scss";

import { PriceChangeProvider } from "../context/price_change/PriceChangeContext";
import { SalesProvider } from "../context/sales_timer/SalesContext";
import { SnackbarProvider } from "notistack";
import deepMerge from "@shopify/app-bridge/actions/merge";
import ErrorBoundary from "./ErrorBoundary";
import AppContext from "../context/appContext";


const yourCustomFetchWrapper = (uri, options) => {
  const aggregateOptions = deepMerge(options, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });
  return fetch(uri, aggregateOptions);
};

function MyProvider(props) {
  const app = useAppBridge();

  const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: new HttpLink({
      credentials: "include",
      fetch: authenticatedFetch(app, yourCustomFetchWrapper),
    }),
  });

  const { Component, ...rest } = props;

  return (
    <ApolloProvider client={client}>
      <ErrorBoundary>
        <Component {...rest} />
      </ErrorBoundary>
    </ApolloProvider>
  );
}
let host,shop1,jwtToken;
function MyApp(props) {

  const { Component, pageProps, host1, shopOrigin, jwtToken1 } = props;

  
  console.error = function () {};
  console.warn = function () {};
  
  if(host1) host=host1;
  if(shopOrigin) shop1=shopOrigin;
  if((NOT_EMBEDDED_STORES.split(',').some((storeName) => shopOrigin == storeName)) && jwtToken1) jwtToken=jwtToken1;

  const isNotRedirectNeeded = NOT_EMBEDDED_STORES.split(',').some((storeName)=>shopOrigin==storeName);
  return (
    <AppContext.Provider value={{ host, jwtToken, shop1 }}>
    <AppProvider i18n={translations}>
      <Provider
        config={{
          apiKey: API_KEY,
          host: host,
          shopOrigin: shopOrigin,
          forceRedirect: NOT_EMBEDDED == "1" || (NOT_EMBEDDED == "0" && isNotRedirectNeeded) ? false : true,
        }}
      >
        <SnackbarProvider maxSnack={3}>
          <DiscountState>
            <PriceChangeProvider>
              <SalesProvider>
                <MyProvider Component={Component} {...pageProps} />
              </SalesProvider>
            </PriceChangeProvider>
          </DiscountState>
        </SnackbarProvider>
      </Provider>
      <Head>
        <link
          rel="stylesheet"
          href="https://cdnjs.cloudflare.com/ajax/libs/react-datepicker/2.14.1/react-datepicker.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Roboto+Slab&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Lato&family=Roboto+Slab&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Lato&family=Montserrat&family=Roboto+Slab&display=swap"
        />
      </Head>
    
      <script
        type="text/javascript"
        src="//code.tidio.co/qxd4dlxibc3ah8hk4lec1kv6ori6kgzi.js"
        async
        // defer
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `document.addEventListener("tidioChat-open", onTidioChatApiOpen);
 
            function onTidioChatApiOpen() {
              document.removeEventListener("tidioChat-open", onTidioChatApiOpen);
              tidioChatApi.messageFromOperator('Hi, how can we help you today?');
              var message = "Hi, I have a question about Bevy Sales Rules";
              tidioChatApi.messageFromVisitor(message);
            }
            `,
        }}
      ></script>
      <script
        dangerouslySetInnerHTML={{
          __html: `document.addEventListener('contextmenu', event => event.preventDefault());`,
        }}
      ></script>
    </AppProvider>
    </AppContext.Provider>
  );
}

MyApp.getInitialProps = async ({ ctx }) => {
  return {
    host1: ctx.query.host,
    shopOrigin: ctx.query.shop,
    jwtToken1: ctx.query.jwtToken,
  };
};

export default MyApp;
